import type { AgentEntityRowsEvent } from '@travel-planner/shared/schemas';
import { pickCss } from '@/shared/lib/css-utils';
import { Text } from '@/shared/ui';
import css from './agent-entity-rows-card.module.scss';

const rootCss = pickCss(css, css.root);
const rowCss = pickCss(css, css.row);

export type AgentEntityRowsCardProps = {
  event: AgentEntityRowsEvent;
};

// Inline result cards for an `entity_rows` stream beat (P2.7) — e.g. the
// products `recommend_products` matched. Renders each entity as a compact row
// (title + optional subtitle) instead of folding the list into one summary
// line, so the consultant sees what the agent found. Display-only; the model
// holds the structured data it needs to chain a follow-up write.
export const AgentEntityRowsCard = ({ event }: AgentEntityRowsCardProps) => {
  if (event.entities.length === 0) return null;

  return (
    <ul className={rootCss()} aria-label={`${event.entityType} results`}>
      {event.entities.map((entity) => (
        <li className={rowCss()} key={entity.id}>
          <Text as="span" size="sm" className={css.title}>
            {entity.title}
          </Text>
          {entity.subtitle && (
            <Text as="span" size="xs" variant="muted" className={css.subtitle}>
              {entity.subtitle}
            </Text>
          )}
        </li>
      ))}
    </ul>
  );
};
